<template>
  <div class="my-20 md:px-0 px-4">
    <h2 class="md:text-3xl text-2xl text-center font-semibold">
      {{ title }}
    </h2>
    <div
      class="flex justify-center min-h-20 relative mt-14 max-w-screen-xl mx-auto"
    >
      <div
        class="absolute md:w-full md:h-[1px] md:top-11 md:left-0 w-[1px] h-full left-1/2 top-0 bg-primary-color -z-10 md:[mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]"
      ></div>
      <div
        class="w-full flex md:flex-row flex-col gap-4 max-w-sm md:max-w-5xl relative md:absolute lg:px-0 px-4"
      >
        <div
          class="cursor-pointer bg-[#FBFCFE] flex-1 group"
          v-for="(data, index) in endToEndData"
          :key="index"
        >
          <div
            class="flex justify-center items-center flex-col gap-1 group-hover:hidden p-3 border border-primary-color rounded-3xl font-semibold text-lg min-h-24"
          >
            <img :src="data.iconPath" class="h-8" />
            <p>{{ data.title }}</p>
          </div>
          <ul
            class="hidden group-hover:flex list-disc bg-[#EFEFFD] h-full py-4 pl-6 border border-transparent rounded-3xl text-sm min-h-24 flex-col justify-center"
          >
            <li v-for="(descript, i) in data.description" :key="i">
              {{ descript }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    endToEndData: Array,
    title: String,
  },
};
</script>
